import React from 'react';
import { gql } from '@common/hooks';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

import { DeprecatedStatePill } from '@common/components';
import { Pending, Sent, Extended } from './helper-text';

export function ExtensionOfferState({
  assignment,
  offer,
  extensionCount,
  fontSize,
}) {
  if (!offer && (!extensionCount || extensionCount === 0)) return null;

  let label;
  let color;
  let tooltip;

  if (offer) {
    if (offer.state === 'active') {
      label = 'Extension Sent';
      tooltip = <Sent supplierName={assignment.supplier.name} />;
    } else if (offer.state === 'pending') {
      label = 'Extension Pending Approval';
      tooltip = <Pending supplierName={assignment.supplier.name} />;
    } else if (offer.state === 'change_requested') {
      label = 'Extension Change Requested';
      tooltip = <Pending supplierName={assignment.supplier.name} />;
    }
    color = 'sky-regular';
  } else {
    label = 'Extended';
    color = 'elm-lightest';
    tooltip = (
      <Extended
        teamMember={assignment.worksProfile.fullName}
        endDate={assignment.finalEndDate}
      />
    );
  }

  let counter = '';

  if (extensionCount && extensionCount > 0) {
    counter = ` | ${extensionCount}`;
  }

  return (
    <Tooltip title={tooltip}>
      <DeprecatedStatePill color={color} fontSize={fontSize}>
        {label} {counter}
      </DeprecatedStatePill>
    </Tooltip>
  );
}

ExtensionOfferState.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
  }),
  extensionCount: PropTypes.number,
  assignment: PropTypes.shape({
    supplier: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
    worksProfile: PropTypes.shape({ fullName: PropTypes.string.isRequired })
      .isRequired,
    finalEndDate: PropTypes.string.isRequired,
  }).isRequired,
  fontSize: PropTypes.string,
};

ExtensionOfferState.fragment = gql`
  fragment ExtensionOfferStateFragment on StaffingRequestAssignment {
    id
    extensionCount
    finalEndDate
    activeExtensionOffer {
      id
      state
    }
    supplier {
      id
      name
    }
  }
`;
